<template lang="pug">
    div
        Row(style="margin: 0px 6px 0px 6px")
            Col(span="24")
                DashboardQueryFilter(
                    :isWithGroupName="true"
                    :isWithTags="false"
                    :isWithServiceGroupName="false"
                    :isWithAppProfileName="false"
                    :isWithServerName="false"
                    :isWithOrigin="false"
                    :isWithEdgeName="true"
                    :isWithSlbName="true"
                )
        Row
            Col(:lg="24", :md="24")
                Card.dashBoardCard
                    LineChartWrapper.dashBoardCard(
                        :chartType="'HostCpuSummaryLineChart'"
                        :chartTitle="'CPU Usage'"
                        :numeralFormat="'0.00%'"
                        :withCard="false"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="colorScheme.colorSets.border"
                        :useBackendDatasetLabel="true"
                        :legendPosition="'right'"
                        :legendAlign="'start'"
                        :apiEndpoint="'/monitor/mbchartdata'"
                    )
            Col(:lg="24", :md="24")
                Card.dashBoardCard
                    LineChartWrapper.dashBoardCard(
                        :chartType="'HostSocketSummaryLineChart'"
                        :chartTitle="'TCP Socket'"
                        :numeralFormat="'0.00a'"
                        :withCard="false"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="colorScheme.colorSets.border"
                        :useBackendDatasetLabel="true"
                        :legendPosition="'right'"
                        :legendAlign="'start'"
                        :apiEndpoint="'/monitor/mbchartdata'"
                    )
        Row
            Col(:lg="24", :md="24")
                Card.dashBoardCard
                    LineChartWrapper.dashBoardCard(
                        :chartType="'HostMemSummaryLineChart'"
                        :chartTitle="'Mem Usage'"
                        :numeralFormat="'0.00%'"
                        :withCard="false"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="colorScheme.colorSets.border"
                        :useBackendDatasetLabel="true"
                        :legendPosition="'right'"
                        :legendAlign="'start'"
                        :apiEndpoint="'/monitor/mbchartdata'"
                    )
            Col(:lg="24", :md="24")
                Card.dashBoardCard
                    LineChartWrapper.dashBoardCard(
                        :chartType="'HostDiskSummaryLineChart'"
                        :chartTitle="'Disk Usage'"
                        :numeralFormat="'0.00%'"
                        :withCard="false"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="colorScheme.colorSets.border"
                        :useBackendDatasetLabel="true"
                        :legendPosition="'right'"
                        :legendAlign="'start'"
                        :apiEndpoint="'/monitor/mbchartdata'"
                    )
        Row
            Col(:lg="12", :md="24")
                Card.dashBoardCard
                    LineChartWrapper.dashBoardCard(
                        :chartType="'HostNetInSummaryLineChart'"
                        :chartTitle="'From Internet'"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="colorScheme.colorSets.border"
                        :useBackendDatasetLabel="true"
                        :legendPosition="'right'"
                        :legendAlign="'start'"
                        :apiEndpoint="'/monitor/mbchartdata'"
                    )
            Col(:lg="12", :md="24")
                Card.dashBoardCard
                    LineChartWrapper.dashBoardCard(
                        :chartType="'HostNetOutSummaryLineChart'"
                        :chartTitle="'To Internet'"
                        :numeralFormat="'bps'"
                        :withCard="false"
                        :linePointRadius="[4]"
                        :linePointHoverRadius="[8]"
                        :linePointBackgroundColor="['white']"
                        :linePointBorderWidth="[3]"
                        :lineBorderColors="colorScheme.colorSets.border"
                        :useBackendDatasetLabel="true"
                        :legendPosition="'right'"
                        :legendAlign="'start'"
                        :apiEndpoint="'/monitor/mbchartdata'"
                    )
</template>
<script>
import bus from "@/libs/bus.js";
import DashboardQueryFilter from "@/components/DashboardQueryFilterV2";

import colorScheme from "@/data/colorScheme";
import SearchChartBtn from "@/components/SearchChartBtn";
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";

export default {
    name: "HardwareStatus",
    components: {
        SearchChartBtn,
        DashboardQueryFilter,
        LineChartWrapper
    },
    data() {
        return {
            chartHeight: 280,
            colorScheme: colorScheme,
            searchBtnIsLoading: false,
            selectedGroupNames: ["*"],
            selectedSlbs: [],
            selectedEdges: [],
            selectedTimerange: "1",
            customTimeRange: []
        };
    },
    methods: {},
    mounted() {},
    computed: {}
};
</script>

<style scoped>
.dashBoardCard {
    text-align: center;
    height: auto;
    margin: 6px 6px 0px 6px;
}
</style>



// WEBPACK FOOTER //
// src/view/monitor/HardwareStatus.vue